var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"finger-print-bg",attrs:{"fluid":""}},[_c('v-container',{staticClass:"my-14 default-gutter",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"4"}},[_c('contact-us-info')],1),_c('v-col',{staticClass:"test",attrs:{"cols":"8"}},[_c('contact-us-form',{on:{"complete":_vm.complete}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }